import yup from "../utility/ValidationUtilty";
import { ConstMessage } from "../config/const";

export type LinkMenus = {
  id: string;
  type?: "Web" | "App";
  name?: string;
  colorName?: string;
  bgColor?: string;
  textColor?: string;
  packageName?: string;
  bundleID?: string;
  url?: string;
  createType?: "admin" | "municipality";
  createUser?: string;
  createAt?: Date;
};

const regex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=[\]]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=[\]]*)$/;

export const linkMenusSchema = yup.object({
  name: yup.string().required().test( (value, testContext)=>{
    let errorMsg = "";
    const nameValue = testContext.parent.name;
    if(nameValue && nameValue !== ""){
      const nameArr = nameValue.split("\n");
      if(nameArr.length > 3){
        errorMsg = ConstMessage.INPUT_ERR_LINK_MENU_NAME_LINE
      }
      let nameErrorFlg = false;
      nameArr.map((name: string) => {
        if(name.length > 10){
          nameErrorFlg = true;
        }
      })
      if(nameErrorFlg){
        errorMsg = errorMsg + ConstMessage.INPUT_ERR_LINK_MENU_NAME_COUNT
      }
      if(errorMsg !== ""){
        return testContext.createError({
          message: errorMsg
        })
      }
    }
    return true;
  }),
  url: yup.string().matches(regex).required(),
});
